<ng-container [formGroup]="formGroup">
    <ng-container *ngIf="showSearch">
        <ng-content select="app-team-member-search"></ng-content>
        <mat-divider *ngIf="search && search.teamMembers.length > 0" orLine></mat-divider>
    </ng-container>

    <ng-container *ngIf="admins?.controls" formArrayName="admins">
        <mat-card *ngFor="let admin of admins.controls; let i = index"
                  [formGroupName]="i"
                  [class.hidden]="!admin.get('isEditing').value"
                  nestedCard animated>
            <mat-card-title>{{ 'Add a new team member' }}</mat-card-title>
            <mat-card-content>
                <div class="form-group">
                    <label for="fullName" requiredMarker>{{ 'Full name' }}</label>
                    <mat-form-field appearance="outline" subscriptSizing="dynamic">
                        <input id="fullName"
                               type="text"
                               formControlName="fullName"
                               matInput
                               [placeholder]="'Full name'"
                               [attr.aria-label]="'Team member full name'">
                    </mat-form-field>
                    <lf-control-messages [control]="admin.get('fullName')" prefix="Name"></lf-control-messages>
                </div>

                <div class="form-group">
                    <label for="email" requiredMarker>{{ 'Email' }}</label>
                    <mat-form-field appearance="outline" subscriptSizing="dynamic">
                        <input id="email"
                               type="text"
                               formControlName="email"
                               matInput
                               [placeholder]="'example@email.com'"
                               [attr.aria-label]="'Team member email address'">
                    </mat-form-field>
                    <lf-control-messages [control]="admin.get('email')" prefix="Email"></lf-control-messages>
                </div>

                <div class="form-group">
                    <label *infoTooltip="roleTooltip">{{ 'Role' }}</label>
                    <mat-form-field appearance="outline" subscriptSizing="dynamic">
                        <mat-select [panelClass]="'v2-panel'" placeholder="{{ 'Select role' }}" formControlName="role">
                            <mat-option [value]="'admin'">{{ 'Community Manager' }}</mat-option>
                            <mat-option [value]="'pmcUser'">{{ 'Property Manager' }}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>

                <div *ngIf="showOrganizationSelect" class="form-group">
                    <label requiredMarker>{{ 'Select assigned communities' }}</label>
                    <mat-form-field appearance="outline" subscriptSizing="dynamic">
                        <mat-select formControlName="organizations" [panelClass]="'v2-panel'" [placeholder]="'Select assigned communities'" multiple>
                            <mat-select-trigger *ngIf="admin.get('organizations').value?.length > 1">
                                <!-- Unable to link the trigger text (when select is open) to match correct count atm -->
                                <ng-template #allSelectedCount>{{ (organizationsList.length | i18nPlural: organizationsMapping) + ' selected' }}</ng-template>
                                <ng-container *ngIf="admin.get('organizations').value[0] !== null; else allSelectedCount">
                                    {{ (admin.get('organizations').value.length | i18nPlural: organizationsMapping) + ' selected' }}
                                </ng-container>
                            </mat-select-trigger>

                            <ng-container *ngIf="organizationsList?.length > 1">
                                <mat-option selectAll [allValues]="organizationsList">{{ 'Select All (' + organizationsList.length + ')' }}</mat-option>
                                <mat-divider></mat-divider>
                            </ng-container>

                            <mat-option *ngFor="let org of organizationsList" [value]="org">{{ org.name }}</mat-option>
                        </mat-select>
                    </mat-form-field>
                    <lf-control-messages [control]="admin.get('organizations')" prefix="Community"></lf-control-messages>
                </div>

                <div class="form-group">
                    <label for="phone">{{ 'Phone (optional)' }}</label>
                    <mat-form-field appearance="outline" subscriptSizing="dynamic">
                        <input id="phone"
                               type="tel"
                               formControlName="phone"
                               matInput
                               [mask]="phoneNumberValidationMask"
                               [placeholder]="phoneNumberValidationMask"
                               [attr.aria-label]="'Team member phone number'">
                    </mat-form-field>
                </div>

                <div class="form-group">
                    <label id="emailNotificationControl">{{ 'Send email invite to the person?' }}</label>
                    <mat-radio-group color="primary"
                                     formControlName="emailNotification"
                                     [attr.aria-labelledby]="'emailNotificationControl'">
                        <mat-radio-button [value]="true" disableRipple>{{ 'Yes' }}</mat-radio-button>
                        <mat-radio-button [value]="false" disableRipple>{{ 'No' }}</mat-radio-button>
                    </mat-radio-group>
                </div>
            </mat-card-content>
            <mat-card-actions>
                <button mat-flat-button color="accent" disableRipple (click)="cancelMember(i)">{{ 'Remove' }}</button>
                <button mat-flat-button color="primary" disableRipple (click)="saveMember(i)">{{ 'Save' }}</button>
            </mat-card-actions>
        </mat-card>
    </ng-container>

    <button mat-fab extended linkButton disableRipple type="button" (click)="addMember()">
        <mat-icon [svgIcon]="'v2:fi-br-plus'"></mat-icon>
        {{ 'Add Another Team Member' }}
    </button>

    <ng-content></ng-content>
</ng-container>
